module.exports = __webpack_public_path__ + "img/Track.dd22effa.svg";